export default __webpack_public_path__ + "static/media/fb.67be8674.svg";